export const purchaseOrderFields = [
  {
    name: "purchaseOrder",
    label: "Purchase Order",
    type: "text",
    required: true,
    disabled: true,
    autoGenerated: true,
    prefetch: true, // Indicates this field should be prefetched/pre-populated
    prefetchFormat: "PO####", // Format template for the generated number
    readOnly: true,
    hiddenOnCreate: true
  },
  {
    name: "externalPoNumber",
    label: "External PO",
    type: "text",
    readOnly: true
  },
  {
    name: "buyerName",
    label: "Buyer/Owner",
    type: "partnerLookup",
    required: true,
    readOnlyInEdit: true
  },
  {
    name: "purchasingOfficeLocation",
    label: "Purchasing Office Location",
    type: "text",

  },

  {
    name: "type",
    label: "Type",
    type: "select",
    noPlaceholder: true,        // ✅ remove the "Select" option
    defaultValue: "Standard",   // ✅ default is Standard (still changeable)
    options: [
      { value: "Standard", label: "Standard" },
      { value: "Flow Thru", label: "Flow Thru" },
      { value: "Stock Transfer", label: "Stock Transfer" }
    ]
  },
  {
    name: "expectedReceiptDate",
    label: "Expected Receipt Date",
    type: "date",
    required: true,
    // defaultValue: (() => {
    //   const d = new Date();
    //   const day = String(d.getDate()).padStart(2, "0");
    //   const month = String(d.getMonth() + 1).padStart(2, "0");
    //   const year = d.getFullYear();
    //   return `${day}-${month}-${year}`;  // dd-mm-yyyy
    // })()

  },
  {
    name: "status",
    label: "Status",
    type: "select",
    options: [
      { value: "New", label: "New" },
      { value: "Other", label: "Other" },
      { value: "InProcess", label: "In Process" },
      { label: "Completed", value: "Completed" },
      { value: "Verified Closed", label: "Verified Closed" }
    ],
    disabled: true,
    readOnly: true,         // added
    // defaultValue: "New"     // added default
  },
  {
    name: "openQuantity",
    label: "Open Quantity",
    type: "number",
    disabled: true,
    readOnly: true,    
  },


  // {
  //   name: "supplierReference",
  //   label: "Supplier Reference",
  //   type: "text",
  //   readOnly: true
  // },
  {
    name: "totalWeight",
    label: "Total Weight",
    type: "text",
    readOnly: true
  },
  {
    name: "totalVolume",
    label: "Total Volume ",
    type: "text",
    readOnly: true

  },
  {
    name: "totalOrderedQuantity",
    label: "Total Order Quantity",
    type: "text",
    readOnly: true
  },
  {
    name: "createdAt",
    label: "Created Date",
    type: "date",
    disabled: true,
    readOnly: true
  },
  {
    name: "closedDate",
    label: "Closed Date",
    type: "date",
    disabled: true,
    readOnly: true
  },

  // {
  //   name: "buyersReference",
  //   label: "Buyer's Reference",
  //   type: "text"
  // },
  // {
  //   name: "externalPoRef2",
  //   label: "External PO Ref2",
  //   type: "text"
  // },

  {
    name: "validityDate",
    label: "Validity Date",
    type: "date",
    required: true,        // ✅ mandatory
    // no hardcoded default here; we set it in CommonFormTab prefill = Created Date + 6 months
  },

  {
    name: "source",
    label: "Source",
    type: "text",
    readOnly: true,
    value: "Internal"  // Default value for new records
  },
  {
    name: "totalPOPrice",
    label: "Total PO Value",
    type: "number",
    // disabled: true,
    readOnly: true,
    defaultValue: ''        // added default
  },
];
export const supplierAddressFields = [
  { name: "supplier", label: "Name", type: "supplierLookup", required: true },
  // { name: "supplierOwner", label: "Source/Owner", type: "text" },
  { name: "addressLine1", label: "Address Line 1", type: "text", required: true },
  { name: "addressLine2", label: "Address Line 2", type: "text" },
  { name: "addressLine3", label: "Address Line 3", type: "text" },
  { name: "addressLine4", label: "Address Line 4", type: "text" },
  { name: "city", label: "City", type: "text", required: true },
  { name: "state", label: "State", type: "text", required: true },
  { name: "country", label: "Country", type: "text", required: true },
  { name: "sellersReference", label: "Reference", type: "text" },
  { name: "contact", label: "Contact", type: "text" },
  { name: "email", label: "Email", type: "email" }
];

// Buyer (Destination)
export const buyerAddressFields = [
  { name: "buyerOwner", label: "Name", type: "customerLookup", required: true },
  { name: "buyerAddressLine1", label: " Address Line 1", type: "text", required: true },
  { name: "buyerAddressLine2", label: " Address Line 2", type: "text" },
  { name: "buyerAddressLine3", label: " Address Line 3", type: "text" },
  { name: "buyerAddressLine4", label: " Address Line 4", type: "text" },
  { name: "buyerCity", label: "City", type: "text", required: true },
  { name: "buyerState", label: "State", type: "text", required: true },
  { name: "buyerCountry", label: "Country", type: "text", required: true },
  { name: "buyersReference", label: "Reference", type: "text" },
  { name: "buyerContact", label: "Contact", type: "text" },
  { name: "buyerEmail", label: "Email", type: "email" }
];
export const miscFields = [
  {
    name: "poHeaderUdf1",
    label: "PO Header UDF1",
    type: "text"
  },
  {
    name: "poHeaderUdf2",
    label: "PO Header UDF2",
    type: "text"
  },
  {
    name: "poHeaderUdf3",
    label: "PO Header UDF3",
    type: "text"
  },
  {
    name: "poHeaderUdf4",
    label: "PO Header UDF4",
    type: "text"
  },
  {
    name: "poHeaderUdf5",
    label: "PO Header UDF5",
    type: "text"
  },
  {
    name: "apportionRule",
    label: "Apportion Rule",
    type: "text",
  },
  {
    name: "notes",
    label: "Notes",
    type: "text"
  },
  {
    name: "termsOfDelivery",
    label: "Terms of Delivery",
    type: "text"
  },
  {
    name: "termsOfPayment",
    label: "Terms of Payment",
    type: "text"

  },
  {
    name: "createByUser",
    label: "Created By",
    type: "text",
    disabled: true,
    readOnly: true
  },
  // {
  //   name: "createDate",
  //   label: "Created Date",
  //   type: "date",
  //   disabled: true,
  //   readOnly: true
  // },
  {
    name: "editedByUser",
    label: "Updated By",
    type: "text",
    disabled: true,
    readOnly: true
  },
  {
    name: "editDate",
    label: "Updated Date",
    type: "date",
    disabled: true,
    readOnly: true
  }
];

export const loadingFields = [
  {
    name: "loadingDate",
    label: "Loading Date",
    type: "date"
  },
  {
    name: "carrier",
    label: "Carrier",
    type: "text"
  },
  {
    name: "placeOfLoading",
    label: "Place of Loading",
    type: "text"
  },
  {
    name: "countryOfOrigin",
    label: "Country of Origin",
    type: "text"
  },
  {
    name: "placeOfDelivery",
    label: "Place of Delivery",
    type: "text"
  },
  {
    name: "countryOfDestination",
    label: "Country of Destination",
    type: "text"
  },
  {
    name: "placeOfDischarge",
    label: "Place of Discharge",
    type: "text"
  },
  {
    name: "termsOfDelivery",
    label: "Terms of Delivery",
    type: "text"
  },
  {
    name: "termsOfPayment",
    label: "Terms of Payment",
    type: "text"
  }
];

export const userDefinedFields = [
  {
    name: "customField1",
    label: "PO Text UDF 1",
    type: "text"
  },
  {
    name: "customField2",
    label: "PO Text UDF  2",
    type: "text"
  },
  // {
  //   name: "customField3",
  //   label: "PO Text UDF 3",
  //   type: "select",
  //   options: [
  //     { value: "", label: "Select..." },
  //     { value: "option1", label: "Option 1" },
  //     { value: "option2", label: "Option 2" },
  //     { value: "option3", label: "Option 3" }
  //   ]
  // },
  {
    name: "customField4",
    label: "PO Text UDF 3",
    type: "text"
  },
  {
    name: "customField5",
    label: "PO Text UDF 4",
    type: "text"
  },
  // { 
  //   name: "customField6", 
  //   label: "Custom Field 6", 
  //   type: "checkbox" 
  // },
  // {
  //   name: "customNotes",
  //   label: "Custom Notes",
  //   type: "textarea"
  // }
];



// items Details



export const itemDetailsFields = [
  { name: "lineNo", label: "Line Number (Auto)", readOnly: true, disabled: true, placeholder: "00001" },
  { name: "skuId", label: "SKU ID", placeholder: "", hasSearch: true, required: true },
  { name: "description", label: "Description", placeholder: "", required: true },
  { name: "itemCube", label: "Item Volume ", type: "number", placeholder: "0" },
  { name: "itemWeight", label: "Item Weight ", type: "number", placeholder: "0" },
  // { name: "supplierLot", label: "Supplier Lot/Batch", placeholder: "" },
  { name: "pack", label: "Pack", placeholder: "STD", hasSearch: false },
  { name: "lpnNo", label: "LPN No", placeholder: "" },
  { name: "batchNum", label: "Batch Num", placeholder: "" },
  {
    name: "uom",
    label: "UOM",
    type: "select",
    options: [
      { value: "EA", label: "EA" },
      { value: "PCS", label: "PCS" },
      { value: "KG", label: "KG" },
      { value: "LBS", label: "LBS" },
      { value: "M", label: "M" },
      { value: "FT", label: "FT" }
    ],
    placeholder: "EA"
  },
  { name: "orderedQty", label: "Order Qty", placeholder: "0", type: "number", required: true },
  { name: "itemPOTolerance", label: "Item PO Tolerance %" },
  { name: "unitPrice", label: "Price per item", placeholder: "0", type: "number", required: true },
  { name: "discount", label: "Discount %", placeholder: "0", type: "number" },
  { name: "tax", label: "Tax %", placeholder: "0", type: "number", required: true },
  //  {name: "totalPrice", label: "Total Price", placeholder: "0", type: "number", readOnly: true },


  {
    name: "qcRequired",
    label: "QC Required",
    type: "select",
    options: [
      { value: "No", label: "No" },
      { value: "Yes", label: "Yes" }
    ],
    placeholder: "No"
  },

  // ✅ New field: Open Qty
  {
    name: "openQty",
    label: "Open Qty",
    readOnly: true,
    disabled: true,
    placeholder: "0",
    showInPOCreation: false, // hide in PO creation
    calculated: true         // handle inside PP
  },

  // ✅ New field: Received Qty
  {
    name: "receivedQty",
    label: "Received Qty",
    readOnly: true,
    disabled: true,
    placeholder: "0",
    showInPOCreation: false, // hide in PO creation
    calculated: true         // handle inside PP
  },

  { name: "status", label: "Status", readOnly: true, disabled: true, options: ["New", "Packed", "InProcess", "Delivered", "Pending", "Other"] }
];


export const userDefinedItemFields = [
  { name: "poLineUdf1", label: "PO Line UDF1", type: "text" },
  { name: "poLineUdf2", label: "PO Line UDF2", type: "text" },
  { name: "poLineUdf3", label: "PO Line UDF3", type: "text" },
  { name: "poLineUdf4", label: "PO Line UDF4", type: "text" },
  { name: "poLineUdf5", label: "PO Line UDF5", type: "text" },
  { name: "createByUser", label: "Create By User", type: "text", disabled: true },
  { name: "createDate", label: "Create Date", type: "datetime-local", disabled: true },
  { name: "editByUser", label: "Edit By User", type: "text", disabled: true },
  { name: "editDate", label: "Edit Date", type: "datetime-local", disabled: true },
  { name: "notes", label: "Notes", type: "textarea" },
];